export class ListExclusionPatternResourcesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resources",
            "baseName": "resources",
            "type": "Array<ResourceReference>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListExclusionPatternResourcesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
